// extracted by mini-css-extract-plugin
export default {"textarea":"FilterMenutextArea_textarea__R1VBm"};